import React, { useEffect, useState } from "react";
import heand from "../Images/emojiwavinghandsign.png";
import HttpClient from "../utils/HttpClient";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { getOwnProfile } from "../Redux/Slice/PostSlice";
import { useNavigate } from "react-router-dom";
import ExchangedYourContactModal from "../Modal/ExchangedYourContactModal";

function Savecontactpopup({ id, data }) {
  const [showPopup, setShowPopup] = useState(false);
  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const [savedContacts, setsavedContacts] = useState([]);
  const [saveContactsButton, setsaveContactsButton] = useState(false);
  const { UserProfileID } = useSelector((state) => state.app);
  const dispatch = useDispatch();
  const navigate = useNavigate();


  // for nonmember connection request
  const handleSaveAccountNonmember = async () => {
    const formData = {
      nonMemberId: id,
    };

    const res = await HttpClient.requestData(
      "send-req-connection",
      "POST",
      formData
    );
    if (res && res?.status) {
      setShowPopup(!showPopup);
      toast.success("Request sent successfully");
    } else {
      toast.error("Contact Saving failed");
    }
  };

  // for nonmember connection request
  const handleSaveAccount = async () => {
    const formData = {
      nonMemberId: id,
    };

    const res = await HttpClient.requestData(
      "send-req-connection",
      "POST",
      formData
    );
    if (res && res?.status) {
      setShowPopup(!showPopup);
      toast.success("Request sent successfully");
    } else {
      toast.error(res?.msg != "Server Error !!" ? res?.msg : "Contact Saving failed");
    }
  };

  // for member
  const _handleSaveAccount = async () => {
    const data = {
      nonMemberId: id,
    };
    const res = await HttpClient.requestData(
      "save-member-contacts",
      "POST",
      data
    );
    if (res && res?.status) {
      setShowPopup(!showPopup);
      toast.success("Contact Saved successfully");
      navigate('/OwnContactlist')
    } else {
      toast.error("Contact Saving failed");
    }
  };

  // for nonmember
  const _handleSaveAccountNonmember = async () => {
    const data = {
      nonMemberId: id,
    };
    const res = await HttpClient.requestData(
      "save-nonmember-contacts",
      "POST",
      data
    );
    if (res && res?.status) {
      setShowPopup(!showPopup);
      toast.success("Contact Saved successfully");
    } else {
      toast.error("Contact Saving failed");
    }
  };

  //Saved contactlist
  const savedContactList = async () => {
    const res = await HttpClient.requestData("member-contacts", "GET", {});
    if (res && res?.status) {
      setsavedContacts(res?.data);
      const flag = res?.data.filter((ele) => ele?.nonMemberData?._id === id);
      setsaveContactsButton(flag?.length !== 0);
    }
  };

  useEffect(() => {
    if (UserProfileID?._id !== id) {
      savedContactList();
    } else {
      navigate("/");
    }
  }, [id, UserProfileID]);

  useEffect(() => {
    dispatch(getOwnProfile());
  }, [dispatch]);

  useEffect(() => {
    if (saveContactsButton == true) {
      navigate("/MemberOtherSavedProfile/" + data?.state?.userName?.trim(), {
        state: data?.state,
      });
    }
  }, [saveContactsButton]);

  return (
    <>
      <section className="Savecontact_sec">
        <div className="content">
          <div className="hand_icon">
            <img src={heand} className="img-fluid" alt="..." />
          </div>
          <div className="">
            <h4 className="head">Dear sir,</h4>

            {
              data?.state?.memberStatus && UserProfileID?.memberStatus ? (
                <>
                  <p className="txtdear">
                    <strong>Welcome to Neoo Search Business Network,</strong><br />
                    I am glad to meet you today. I forgive you in my business community.
                  </p>
                </>
              ) : (
                <>
                  <p className="txtdear">
                    Welcome to Neoo Search Business
                    Network, Nice to see you today. I invite
                    you to my business community.
                    <br />
                    {
                      !UserProfileID &&
                      <span>
                        {" "}
                        Please fill out the below form and exchange
                        our contact information.
                      </span>
                    }

                  </p>
                </>
              )
            }






          </div>
        </div>
        <div className="btn_area">
          {/* {UserProfileID?._id !== id && (
            <button className="exchangecont_btn">Exchange Contact</button>
          )} */}

          {
            // !saveContactsButton && UserProfileID?.memberStatus && (
            !saveContactsButton && (
              <button
                type="button"
                className="savecontact_btn"
                accordion
                onClick={() => handleSaveAccount()}
              >
                <i className="fa-solid fa-user-plus"></i>
                Connect
              </button>
            )}


          {/* <button
            type="button"
            className="savecontact_btn"
             onClick={togglePopup}
          >
            <i className="fa-solid fa-user-plus"></i>
            Save Contact
          </button> */}
        </div>
      </section>

      {showPopup && <ExchangedYourContactModal onClose={togglePopup} UserProfileID={UserProfileID} />}
    </>
  );
}

export default Savecontactpopup;
